module.exports = __webpack_public_path__ + "img/scene-porch-piano.0b2c69ce.jpg";